module.exports = __webpack_public_path__ + "img/down-btn.2be80d3b.svg";